"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHeaders = exports.isErrorWithAttr = exports.isString = void 0;
function isString(valeur) {
    return !!valeur && typeof valeur === 'string';
}
exports.isString = isString;
function isErrorWithAttr(error, attNames) {
    return (typeof error === 'object' &&
        error != null &&
        !attNames.map(function (att) { return att in error; }).includes(false));
}
exports.isErrorWithAttr = isErrorWithAttr;
function setHeaders(res, path, stat) {
    if (!path.includes('src/bundles/spa/assets/') ||
        path.endsWith('src/bundles/spa/assets/spa/index.html')) {
        return;
    }
    res.setHeader('Cache-Control', 'public, max-age=259200');
}
exports.setHeaders = setHeaders;
